export default {
  get: {

  },
  post: {
    getSubjectList: '/company-store/api/corpapi/subject/query',// 主体列表
    getSubjectListByName: '/company-store/api/corpapi/subject/getSubjectListByName',//根据名字查询主体
    getSubjectDetail: '/company-store/api/corpapi/subject/detail',// 主体详情
    subjectCreate: '/company-store/api/corpapi/subject/create', // 创建主体
    subjectUpdate: '/company-store/api/corpapi/subject/update',// 编辑主体
    getVerifySubjectRecord: '/company-store/api/corpapi/subject/auditLog', //审核记录
    bindCompany: '/company-store/api/corpapi/subject/bindCompany',// 绑定门店
    unbindCompany: '/company-store/api/corpapi/subject/unbindCompany',// 解绑门店
    listCompany: '/company-store/api/corpapi/subject/listCompany',// 门店绑定列表
    getBankList: '/company-store/api/corpapi/payclear/getBankListByAuthMethod', //按照银联鉴权/小额鉴权 获取银行信息
    getBranches: '/company-store/api/corpapi/payclear/getBranch', //获取支行信息
    bindCard: '/company-store/api/corpapi/payclear/bindAccountCard', //绑定二清银行卡
    reconfirmBindCard: '/company-store/api/corpapi/payclear/reconfirmBindAccountCard', //重新绑定二清银行卡
    queryTransferAccountsResult: '/company-store/api/corpapi/payclear/queryTransferAccountsResult', //实时查询 二清绑卡小额鉴权提交认证后的转账结果
    bindAccountCardCheck: '/company-store/api/corpapi/payclear/bindAccountCardCheck', //银行卡鉴权
    getAccountCardList: '/company-store/api/corpapi/payclear/getAccountCardList', //绑卡列表
    getAccountCardDetails: '/company-store/api/corpapi/payclear/getAccountCardDetails', //绑卡详情
    cancelAccountCard: '/company-store/api/corpapi/payclear/cancelAccountCard', //小额授权取消认证/解绑
    getBillList: '/company-store/api/corpapi/subjectbill/getList', //主体账单列表
    getBillDetail: '/company-store/api/corpapi/subjectbill/getDetail', //主体账单详情
    billReview: '/company-store/api/corpapi/subjectbill/review', //账单审核
    billExport: '/company-store/api/corpapi/subjectbill/export', //账单导出
    getBillRecord: '/company-store/api/corpapi/subjectbill/billRecord', //账单流水明细
    totalWaitSettlementAmount: '/company-store/api/corpapi/subjectbill/totalWaitSettleAmount', //总的待结算金额
    batchReviewBill: '/company-store/api/corpapi/subjectbill/batchReviewBill', //批量确认账单
    billRecordExport: '/company-store/api/corpapi/subjectbill/exportRecord', //账单流水导出
  }
}